export default "__VITE_ASSET__817abd7c__"